import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  access_token: "",
  isLogin: false,
  user: null,
  mode: "light",
  isOpen: false,
};

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  //   reducer needs a map
  reducers: {
    saveLoginUserData(state, action) {
      state.user = action.payload.data.user;
      state.isLogin = true;
      state.access_token = action.payload.token;
    },
    signOutRequest(state) {
      state.access_token = "";
      state.isLogin = false;
      state.user_type = "";
      state.user = null;
    },
    ToggleDrawer(state, action) {
      state.isOpen = action.payload;
    },
  },
});

export const { saveLoginUserData, signOutRequest, ToggleDrawer } =
  authSlice.actions;

export default authSlice.reducer;
